import { Grid } from '@mui/material';
import { TRANSPORT_MODES, TransportModes } from '@nx-smartmonkey/shared/domain';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';

import { SelectPill } from '../../../components/SelectPill';
import { getVehicleTypeIcon } from '../../../components/VehicleTypeIcon';
import Button from '../../../react-components/Button';
import { Text } from '../../../react-components/Text';

interface RegisterVehicleTypeProps {
  nextStep: (transportMode: TransportModes) => void;
}

export const RegisterVehicleType = ({ nextStep }: RegisterVehicleTypeProps) => {
  const [vehicleType, setVehicleType] = useState<TransportModes>(TRANSPORT_MODES[0]);

  return (
    <Grid container flexDirection="column" gap="24px">
      <Grid container flexDirection="column" flexGrow="1" flexWrap="nowrap">
        <Text
          intlId="drivers.register.vehicle_type.title"
          variant="h6"
          style={{ marginBottom: `24px`, textAlign: `center` }}
        />

        {TRANSPORT_MODES.map((transportMode, index) => (
          <>
            <SelectPill
              radialIconPosition="right"
              key={transportMode}
              onClick={() => {
                setVehicleType(transportMode);
              }}
              selected={vehicleType === transportMode}
            >
              <Grid container direction="row" gap="8px" alignItems="center">
                <img src={getVehicleTypeIcon(transportMode)} alt="" />
                <Text intlId={`driver.stops.config.preferences.vehicle_type.${transportMode}`} />
              </Grid>
            </SelectPill>
            {index < TRANSPORT_MODES.length - 1 && <VSpacer small />}
          </>
        ))}
      </Grid>

      <Button
        onClick={() => {
          if (nextStep) {
            nextStep(vehicleType);
          }
        }}
        intlId="drivers.register.register"
        style={{
          fontSize: `14px`,
          fontWeight: 400,
        }}
      />
    </Grid>
  );
};
